import React from 'react';
import 'react-widgets/dist/css/react-widgets.css';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import GridItem from 'components/core/Grid/GridItem';
import Button from 'components/core/CustomButtons/Button';
import SubmitButton from 'components/core/CustomButtons/SubmitButton';
import Card from 'components/core/Card/Card';
import CardHeader from 'components/core/Card/CardHeader';
import CardBody from 'components/core/Card/CardBody';
import { Multiselect } from 'react-widgets';
import { TextField, Select, OutlinedInput, MenuItem } from '@material-ui/core';

class AuditRejectForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reasons: [],
      notes: '',
      decisionBy: 0,
    };
  }

  handleNotesChange = event => {
    this.setState({
      notes: event.target.value,
    });
  };

  handleDecisionByChange = event => {
    this.setState({
      decisionBy: event.target.value,
    });
  };

  handleRejectReasonChange = value => {
    const array = [];
    value.map(data => array.push(data.id));
    this.setState({ reasons: array });
  };

  handleRejection = () => {
    this.props.onSubmit(this.state.reasons, this.state.decisionBy, this.state.notes);
    this.props.onCancel();
  };

  render() {
    const { classes, selectReason = [], onCancel } = this.props;
    const TagItem = ({ item }) => (
      <span>
        <strong>{item.name}</strong>
      </span>
    );

    return (
      <Card>
        <CardHeader className={classes.header}>
          <p className={classes.title}>تسجيل الطلب كإجراء خاطئ</p>
        </CardHeader>
        <CardBody className={classes.modalContainer}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl className={classes.row}>
              <div>
                <label className={classes.mLabel}>سبب الخطأ</label>
              </div>
              <div>
                <Multiselect
                  data={selectReason}
                  tagComponent={TagItem}
                  textField="name"
                  valueField="id"
                  onChange={value => this.handleRejectReasonChange(value)}
                  caseSensitive={false}
                  filter="contains"
                />
              </div>
            </FormControl>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <FormControl className={classes.row}>
              <label className={classes.mLabel}>مصدر الخطأ</label>
              <div>
                <Select
                  onChange={this.handleDecisionByChange}
                  value={this.state.decisionBy}
                  input={<OutlinedInput name="type" />}
                  className={classes.escalationSelect}
                >
                  <MenuItem value={0}>
                    <span style={{ color: '#9f9ca2' }}>مصدر الخطأ</span>
                  </MenuItem>
                  <MenuItem value="automation">
                    <span>Automation</span>
                  </MenuItem>
                  <MenuItem value="backoffice">
                    <span>Backoffice</span>
                  </MenuItem>
                </Select>
              </div>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl className={classes.row}>
              <TextField
                multiline
                rows={4}
                variant="outlined"
                label="ملاحظات إضافية"
                value={this.state.notes}
                onChange={this.handleNotesChange}
              />
            </FormControl>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <div className={classes.modalFooter}>
              <Button color="danger" outline onClick={onCancel}>
                الغاء
              </Button>
              <SubmitButton
                color="primary"
                onClick={this.handleRejection}
                disabled={!this.state.reasons[0] || !this.state.decisionBy}
              >
                إرسال
              </SubmitButton>
            </div>
          </GridItem>
        </CardBody>
      </Card>
    );
  }
}

AuditRejectForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  selectReason: PropTypes.array.isRequired,
};

export default AuditRejectForm;
